import templateUrl from "emun.cart/cart-creditcard.htm";
import Shared from "emun.cart/cart.controller";
import resolve from "ioc/resolve";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import ServiceBus from "servicestack/service-bus";
import payfabricPrompt from "emun.cart/payfabric/cart-creditcard-payfabric-prompt";
import docCookies from "webutils/services/doc-cookies";
import modals from "webmodals/modals";

export class CartCreditCardController extends Shared {
	constructor($cart, $scope, $sce) {
		super($cart, $scope, $sce);
		let $stateParams = resolve("$stateParams");
		let shared_token = docCookies.getItem("shared_token");
		let shared_cart_id = docCookies.getItem("shared_cart_id");
		if ($stateParams.cartId && $stateParams.token) {
		  $cart.load($stateParams.cartId || shared_cart_id, $stateParams.token || shared_token);
		} else if (shared_token && shared_token != "undefined" && shared_cart_id && shared_cart_id != "undefined") {
			$cart.load(shared_cart_id, shared_token);
		}
		let $ctrl = this;
		$ctrl.b2c = $cart.businessModel === "Retail";
		$ctrl.purchaserType = $ctrl.b2c ? "Consumer" : "Retailer";
		$ctrl.useAptean = $cart.config.useAptean($cart);
    $ctrl.usePayfabric = $cart.config.usePayfabric($cart);
		$ctrl.useVersapay = $cart.config.useVersapay;
		$ctrl.useNmi = $cart.config.useNmi;
		$ctrl.useUsaepay = $cart.config.useUsaepay;
    $ctrl.useTokenex = $cart.config.useTokenex($cart);
    $ctrl.useHostedPCI = $cart.config.useHostedPCI($cart);
		$ctrl.config = $cart.config;
		$ctrl.paymentMethod = {};
		if (!$cart.purchaser.id) {
			$cart.purchaser.id = $ctrl.retailerId;
		}
    var paymentMethodsUrl = `QueryPaymentMethods/${$cart.businessModel}/${
      $cart.retailerId || $cart.purchaser.id
    }.json?JsConfig=ExcludeDefaultValues`;

    if ($ctrl.usePayfabric) {
      if ($cart.vendorCustomerId) {
        paymentMethodsUrl = `QueryPaymentMethods/${$cart.businessModel}/${$cart.vendorCustomerId || $cart.retailerId || $cart.purchaser.id}.json?JsConfig=ExcludeDefaultValues&UsePayFabric=1`;
      } else {
        $cart.applyPaymentTerms({paymentTermsId: "Pending Card"}).then(function() {
          $cart.load($stateParams.cartId);
        });
      }
    }
    $ctrl.hostName = window.location.protocol + "//" + window.location.hostname;
    if ($ctrl.hostName.indexOf("localhost") > -1) $ctrl.hostName = $ctrl.hostName + ":" + window.location.port;
    $ctrl.hpciIframeUrl = $sce.trustAsResourceUrl(`https://cci.framehpci.com/iSynSApp/showPxyPage!ccFrame.action?pgmode1=prod&locationName=checkout1&sid=534961&reportCCType=Y&reportCCDigits=Y&formatCCDigits=Y&formatCCDigitsDelimiter=-&reportCVVDigits=Y&formatCCMaskMode=S6X6&formatCCMaskChar=*&enableEarlyToken=Y&reportInit=Y&fullParentHost=${$ctrl.hostName}&fullParentQStr=/#/checkout`);
    //console.debug("BL*** hpciIframeUrl", $ctrl.hpciIframeUrl);

    $ctrl.paymentMethodsQuery = new AutoQuery({
			url: paymentMethodsUrl,
			autoLoad: true,
      scrub: (res) => {
        if ($ctrl.useAptean) {
          res.data.results = res.data.results.filter(
            (cc) => cc.tokenizationProvider == "Aptean"
          );
        } else {
          res.data.results = res.data.results.filter(
            (cc) => cc.tokenizationProvider !== "Aptean" 
          );
        }
      },
			onLoaded(args) {
				args.results = args.results.filter(cc => cc.meta.IsExpired === "False");
				args.total = args.results.length;
				if (args.total == 1) {
					args.first.selected = true;
					Object.assign($ctrl.paymentMethod, args.first);
					$ctrl.ccMode = "CHANGE";
          setTimeout(function() {
            $ctrl.selectCC(args.first);
          },500);
				} else if (args.total > 1) {
					args.results.forEach(cc => (cc.selected = false));
					let selCC = args.results.filter(
						cc => cc.id === $cart.paymentMethod.id
					)[0];
					if (!selCC) {
						selCC = args.results.filter(cc => cc.meta.IsPrimary === "True")[0];
					}
					if (!selCC) {
						selCC = args.results[0];
					}

					if (selCC) {
						$ctrl.ccMode = "CHANGE";
						selCC.selected = true;
						Object.assign($ctrl.paymentMethod, selCC);
            setTimeout(function() {
              $ctrl.selectCC(args.first);
            },500);
					}
				} else {
					//if ($cart.paymentMethod.id) {
					//	$ctrl.ccMode = "CHANGE";
					//} else {
						$ctrl.paymentMethod.country = "US";
						if (!$cart.config.snapPayPage) $ctrl.newCard();
						else $ctrl.ccMode = "CHANGE";
					//}
				}
				console.info("$ctrl.newCardID", $ctrl.newCardID);
				//assign the Payment Method to the cart
				if ((!$ctrl.$cart.paymentMethod.id && ($ctrl.paymentMethod.id || $ctrl.paymentMethod.number)) ||
					($ctrl.$cart.paymentMethod.id && $ctrl.paymentMethod.id && $ctrl.$cart.paymentMethod.id !== $ctrl.paymentMethod.id)
				) {
					$ctrl.$cart.applyPaymentMethod($ctrl.paymentMethod, $ctrl.$cart.id);
				}
				if ($ctrl.newCardID && $ctrl.newCardID != undefined && $ctrl.newCardID != "") {
					let selCC = args.results.filter(cc => cc.token === $ctrl.newCardID)[0];
					$ctrl.paymentMethodsQuery.results.forEach(function (res) {
						res.selected = false;
						if (selCC.id == res.id) {
							res.selected = true;
						}
					});
					Object.assign($ctrl.paymentMethod, selCC);
					$ctrl.paymentMethod.cvv = "";
					$ctrl.$cart.paymentMethod.lastFour = "";
					$ctrl.ccMode = "CHANGE";
					$ctrl.$cart.applyPaymentMethod(selCC, $ctrl.$cart.id);
				}
			}
		});
		let $rootScope = resolve("$rootScope");
		$rootScope.$on('creditCardCreated', (e,args) => {
			$ctrl.ccMode = "CHANGE";
			$ctrl.newCardID = args.ID || args.id;
			$ctrl.paymentMethodsQuery.load(true);
		});
		if ($ctrl.$cart.config.snapPayPage ) {
			$ctrl.$cart.bus.send("SnapPay/QuerySnapPayRequests?PrincipalId=" + $cart.retailerId).then(function(res) {
				if (res.data.results.length) {
					$ctrl.$cart.bus.send("SnapPay/GetPaymentDetails.json", {CartId: $ctrl.$cart.id, RetailerId: $ctrl.$cart.retailerId, RequestId: res.data.results[0].requestId}).then(function(pd) {
						if (pd.data) {
							window.location.reload();
						}
					});
				}
			});
		} 
	}
	selectCC(selCC) {
		let $ctrl = this;
		$ctrl.paymentMethodsQuery.results.forEach(function (res) {
			res.selected = false;
			if (selCC.id == res.id) {
				res.selected = true;
			}
		});
		Object.assign($ctrl.paymentMethod, selCC);
		$ctrl.paymentMethod.cvv = "";
		$ctrl.$cart.paymentMethod.lastFour = "";
		$ctrl.ccMode = "CHANGE";

    if ($ctrl.$cart.id) {
      $ctrl.$cart.applyPaymentMethod(selCC, $ctrl.$cart.id);
    }
  }
  toggleSameAsCorporate() {
    let $ctrl = this;
    if ($ctrl.sameAsCorporate) {
      $ctrl.paymentMethod.address =
        $ctrl.$cart.purchaser.address || $ctrl.$cart.billingLocation.address;
      $ctrl.paymentMethod.address2 =
        $ctrl.$cart.purchaser.address2 || $ctrl.$cart.billingLocation.address2;
      $ctrl.paymentMethod.city =
        $ctrl.$cart.purchaser.city || $ctrl.$cart.billingLocation.city;
      $ctrl.paymentMethod.state =
        $ctrl.$cart.purchaser.state || $ctrl.$cart.billingLocation.state;
      $ctrl.paymentMethod.zip =
        $ctrl.$cart.purchaser.zip || $ctrl.$cart.billingLocation.zip;
      $ctrl.paymentMethod.country =
        $ctrl.$cart.purchaser.country || $ctrl.$cart.billingLocation.country;
    }
  }
  newCard() {
    let $ctrl = this;
    $ctrl.sameAsCorporate = true;
    $ctrl.ccMode = "NEW";
    $ctrl.paymentMethod.id = "";
    $ctrl.paymentMethod.number = "";
    $ctrl.paymentMethod.name = "";
    $ctrl.paymentMethod.expirationMonth = "";
    $ctrl.paymentMethod.expirationYear = "";
    $ctrl.paymentMethod.expiration = "";
    $ctrl.paymentMethod.expiresOn = "";
    $ctrl.paymentMethod.cvv = "";
    $ctrl.paymentMethod.lastFour = "";
    $ctrl.paymentMethod.provider = "";
    $ctrl.paymentMethod.network = "";

    $ctrl.paymentMethod.address = $ctrl.$cart.purchaser.address;
    $ctrl.paymentMethod.address2 = $ctrl.$cart.purchaser.address2;
    $ctrl.paymentMethod.city = $ctrl.$cart.purchaser.city;
    $ctrl.paymentMethod.state = $ctrl.$cart.purchaser.state;
    $ctrl.paymentMethod.zip = $ctrl.$cart.purchaser.zip;
    $ctrl.paymentMethod.country = $ctrl.$cart.purchaser.country || "US";
    if ($ctrl.useTokenex) $ctrl.loadTokenEx();

    // $ctrl.triggerTokenization = function() {
    //   console.debug("BL*** posting tokenize message");
    //   sendHPCIMsg();
    // };

  }

  loadTokenEx() {
    let $ctrl = this;
		let $rootScope = resolve("$rootScope");
    $ctrl.$cart.bus.send("TokenEx/GenerateAuthenticationKey").then(function(res) {
      $ctrl.iframeConfig = {
        debug: true,
        origin: window.location.protocol + "//" + window.location.host, // $ctrl.$cart.config.tokenExOrigin,
        timestamp: res.data.timestamp,
        tokenExID: $ctrl.$cart.config.tokenExId,
        tokenScheme: "PCI",
        authenticationKey: res.data.key,
//        cvv: true,
//        cvvContainerID: "cvvID",
        pci: true,
        enablePrettyFormat: true,
        title: "Card Number",
//        cvvTitle: "CVV",
        inputType: "text",
        styles: {
          base: "font-family: Arial, sans-serif;padding: 0 8px;border: 1px solid rgba(0, 0, 0, 0.2);margin: 0;width: 100%;font-size: 13px;line-height: 30px;height: 32px;box-sizing: border-box;-moz-box-sizing: border-box;",
          focus: "box-shadow: 0 0 6px 0 rgba(0, 132, 255, 0.5);border: 1px solid rgba(0, 132, 255, 0.5);outline: 0;",
          error: "box-shadow: 0 0 6px 0 rgba(224, 57, 57, 0.5);border: 1px solid rgba(224, 57, 57, 0.5);",
        }
      }
      console.debug("BL*** iframeConfig", $ctrl.iframeConfig);
      $ctrl.iframe = new TokenEx.Iframe("tokenExIframeDiv", $ctrl.iframeConfig);
      $ctrl.iframe.on("tokenize", function(data) {
        console.debug("CC iFrame Tokenize:" + JSON.stringify(data));
        $ctrl.paymentMethod.tokenizationProvider = "TokenEx";
        $ctrl.paymentMethod.tokenizationCode = data.token;
        $ctrl.paymentMethod.number = "TOKEN";
        $ctrl.paymentMethod.type = data.cardType;
        $ctrl.paymentMethod.network = data.cardType;
        $ctrl.paymentMethod.provider = data.cardType;
        $ctrl.paymentMethod.lastFour = data.lastFour;
        $ctrl.paymentMethod.isPrimary = true;

        $ctrl.$cart.bus
          .send(
            "Create" + $ctrl.purchaserType + "PaymentMethod.json",
            $ctrl.paymentMethod
          )
          .then(function (response) {
//            $ctrl.$cart.applyPaymentMethod(response, $ctrl.$cart.id);
            $ctrl.newCardID = data.token;
            $rootScope.$broadcast("creditCardCreated", { id: data.token});
            // $ctrl.paymentMethodsQuery.load(true);
            // $ctrl.ccMode = "CHANGE";
            // $ctrl.$cart.paymentMethod.lastFour = "";
          }, $ctrl.$cart.errorToastFactory("saveCardFailed"));

      });
      $ctrl.iframe.load();
    });
  }
  saveCard() {
    let $ctrl = this;
    //$ctrl.paymentMethod.name = $ctrl.paymentMethod.companyName = $ctrl.purchaser.companyName;
    $ctrl.paymentMethod.isPrimary = true;
    $ctrl.paymentMethod.retailerId =
      $ctrl.$cart.purchaser.id || $ctrl.$cart.retailerId;
    $ctrl.paymentMethod.expiration =
      $ctrl.paymentMethod.expirationMonth + $ctrl.paymentMethod.expirationYear;
    $ctrl.paymentMethod.expiresOn =
      $ctrl.paymentMethod.expirationMonth +
      "/1/" +
      $ctrl.paymentMethod.expirationYear;
    $ctrl.paymentMethod.cartId = $ctrl.$cart.id;
    console.debug("$ctrl.$cart", $ctrl.$cart);
    console.debug(
      "$ctrl.$cart.errorToastFactory",
      $ctrl.$cart.errorToastFactory
    );
    if ($ctrl.useTokenex) $ctrl.iframe.tokenize();
    else if ($ctrl.useHostedPCI) {
      var ccNumInput = document.getElementById("cc-token");
      var ccTypeInput = document.getElementById("cc-type");
      var ccLastFour = document.getElementById("cc-last4");
      console.debug("BL*** cc token", ccNumInput.value);
      if (!ccNumInput.value) {
        modals.alert("Invalid credit card #");
        return;
      } 
      $ctrl.paymentMethod.tokenizationProvider = "HostedPCI";
      $ctrl.paymentMethod.tokenizationCode = ccNumInput.value;
      $ctrl.paymentMethod.number = "TOKEN";
      $ctrl.paymentMethod.type = ccTypeInput.value;
      $ctrl.paymentMethod.network = ccTypeInput.value;
      $ctrl.paymentMethod.provider = ccTypeInput.value;
      $ctrl.paymentMethod.lastFour = ccLastFour.value;
      $ctrl.paymentMethod.isPrimary = true;

      let $rootScope = resolve("$rootScope");
      $ctrl.$cart.bus
        .send(
          "Create" + $ctrl.purchaserType + "PaymentMethod.json",
          $ctrl.paymentMethod
        )
        .then(function (response) {
          $ctrl.newCardID = response.data.tokenizationCode;
          // $ctrl.$cart.bus.send("HostedPCI/GetGatewayToken", {
          //   VendorId: $ctrl.$cart.vendorId,
          //   RetailerId: $ctrl.$cart.retailerId,
          //   Token: $ctrl.newCardID,
          //   OrderNumber: $ctrl.$cart.id
          // }).then(function(gatewayResponse) {
          //     if (gatewayResponse.data.status == "error") {
          //       $ctrl.gatewayErrors = [];
          //       console.debug("BL*** gatewayResponse", gatewayResponse);
          //       if (gatewayResponse.data.errId == "PPA_ACT_6") {
          //         $ctrl.gatewayErrors.push([
          //         {
          //           errorCode: gatewayResponse.data.errId,
          //           fieldName: "CreditCard",
          //           message: "No payment profile created for vendor " + $ctrl.$cart.vendorId
          //         }]);
          //       } else {
          //         $ctrl.gatewayErrors.push([
          //           {
          //             errorCode: gatewayResponse.data.gatewayResponseCode,
          //             fieldName: "CreditCard",
          //             message: gatewayResponse.data.gatewayResponseStatus
          //           }]);
          //       }
          //     }
          // });
          $rootScope.$broadcast("creditCardCreated", { id: response.data.tokenizationCode});
        }, $ctrl.$cart.errorToastFactory("saveCardFailed"));

    }
    else {
      $ctrl.$cart.bus
      .send(
        "Create" + $ctrl.purchaserType + "PaymentMethod.json",
        $ctrl.paymentMethod
      )
      .then(function (response) {
        //$ctrl.$cart.applyPaymentMethod(response, $ctrl.$cart.id);
        $ctrl.newCardID = response.data.tokenizationCode;
        $ctrl.paymentMethodsQuery.load(true);
        $ctrl.ccMode = "CHANGE";
        $ctrl.$cart.paymentMethod.lastFour = "";
      }, $ctrl.$cart.errorToastFactory("saveCardFailed"));
    }
  }
  deleteCard(paymentMethod) {
    let $ctrl = this;
    let bus = new ServiceBus();
    console.info("delete card", paymentMethod);
    return modals
      .confirm(
        "Are you sure you want to delete card ending in " +
          paymentMethod.lastFour +
          "?",
        "Delete Payment Method"
      )
      .result.then(function () {
        //let request = Object.assign({}, paymentMethod);
        let request = {
          Id: paymentMethod.id,
          RetailerId: paymentMethod.meta.RetailerId,
        };
        if ($ctrl.$cart.businessModel === "Wholesale") {
          bus
            .send("DeleteRetailerPaymentMethod.json", request)
            .then(function () {
              $ctrl.paymentMethodsQuery.load(true);
              $ctrl.ccMode = "CHANGE";
              $ctrl.$cart.paymentMethod.lastFour = "";
            }, $ctrl.$cart.errorToastFactory("deleteCardFailed"));
        } else {
          console.debug("$ctrl.$cart", $ctrl.$cart);
          console.debug(
            "$ctrl.$cart.errorToastFactory",
            $ctrl.$cart.errorToastFactory
          );
          bus
            .send("DeleteConsumerPaymentMethod.json?Id=", request)
            .then(function (response) {
              $ctrl.paymentMethodsQuery.load(true);
              $ctrl.ccMode = "CHANGE";
              $ctrl.$cart.paymentMethod.lastFour = "";
            }, $ctrl.$cart.errorToastFactory("deleteCardFailed"));
        }
      });
  }
}

export default {
  controller: CartCreditCardController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
